<h1 class="title-center">LOS Talker Clients</h1>
<br />

@if(settingsReady)
{
  <app-lt-png-table [gridSettingsInput]="gridSettings()" (selectionChange)="handleSelectedRow($event)" />
}

<div class="inline" *ngIf="checkAccess(['LOSTalker.Admin'])">
  <span>Show Hidden Clients</span>

  <app-lt-switch class="my-1"
    [onLabel]="'Show'"
    [offLabel]="'Hide'"
    [(ngModel)]="showHiddenClients"
    (toggleChange)="updateHiddenClientView($event)"></app-lt-switch>
</div>
